
    export const isVisuallyEmptyTextEditor = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }
    export const removeTrailingEmptyLinesTextEditor = (html) => {
        return html.replace(/(<p><br><\/p>\s*)+$/g, '');
    }
    export const getPlainTextFromHtml = (html) => html.replace(/<[^>]*>/g, ' ').trim();